const scrollAnimationMaxWidth = 992;
// import * as $ from 'jquery';
import $ from 'jquery';

export default class MobileAnimationService {

    scrollToOption(root: any, currentSelection: any, selector = '.tabcontent .scrolling-container') {
        if (!root || !this.isMobile() || !$(selector).length) {
            return
        }
        if (currentSelection) {
            this.scrollToSelected(selector)
        } else {
            this.scrollToFirstOption(selector)
        }
    }

    private scrollToSelected(selector: string) {
        const scrollingContainer = $(selector)
        const tabcontent = scrollingContainer.parent('.tabcontent')
        const contentContainer = scrollingContainer.parent('.content-container')

        scrollingContainer.find('ul.options-list li:first-child').css("marginLeft", "0px"); // just in case
        const ele = scrollingContainer.find("li.selected")!;
        if (ele.length > 0) {
            let offset = 10;
            let tabsize = tabcontent.outerWidth()! + 10;
            let docWidth = $(window).width()!;
            if (docWidth - tabsize > 100) {   // landscape
                offset = (1 - (tabsize / docWidth)) * docWidth;
            }
            contentContainer.scrollLeft(0);
            contentContainer.scrollLeft(ele.offset()!.left - offset); // -- 316
        }
        else {
            console.trace("scroll element not found")
        }
    }

    private scrollToFirstOption(selector: string) {
        const scrollingContainer = $(selector)
        const contentContainer = scrollingContainer.parent('.content-container')
        contentContainer.scrollLeft(0);
        scrollingContainer.find('li:first-child').css("marginLeft", $(window).width()! + "px");
        scrollingContainer.find('li:first-child').animate({ 'marginLeft': '0px' }, 500);
    }

    isMobile() {
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        return width <= scrollAnimationMaxWidth;
    }
}